export default {"src":"/_next/static/media/error-circle-hazard.adca707a.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};